// extracted by mini-css-extract-plugin
export default {"container":"CampaignDashboardTabGeneric_container__PIQv8","header":"CampaignDashboardTabGeneric_header__xPheJ"};